import React from 'react';

interface SelectionRect {
  startX: number;
  startY: number;
  currentX: number;
  currentY: number;
}

interface PartnrSelectionRectProps {
  rect: SelectionRect;
  zoom: number;
  panX: number;
  panY: number;
  isPartnrMode?: boolean;
}

export function PartnrSelectionRect({ rect, isPartnrMode = true }: PartnrSelectionRectProps) {
  const left = Math.min(rect.startX, rect.currentX);
  const top = Math.min(rect.startY, rect.currentY);
  const width = Math.abs(rect.currentX - rect.startX);
  const height = Math.abs(rect.currentY - rect.startY);

  // Don't render if too small (prevents accidental tiny rectangles)
  if (width < 5 && height < 5) return null;

  return (
    <div
      className={`absolute pointer-events-none rounded-lg ${
        isPartnrMode 
          ? 'border-2 border-dashed partnr-referenced-border' 
          : 'border-2 border-dashed border-primary bg-primary/10'
      }`}
      style={{
        left,
        top,
        width,
        height,
        zIndex: 50,
        ...(isPartnrMode ? { backgroundColor: 'hsl(var(--partnr) / 0.05)' } : {}),
      }}
    />
  );
}
